// Urbixx — Contact page (premium)
(function() {
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function readConfig() {
    try {
      var el = document.getElementById("urbixx-contact-config");
      if (!el) return null;
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return null;
    }
  }

  function initCountrySelect() {
    var wrap = qs("[data-urbixx-country-select]");
    if (!wrap) return;

    var btn = qs(".urbixx-country-btn", wrap);
    var menu = qs(".urbixx-country-menu", wrap);
    var codeEl = qs("[data-urbixx-country-code]", wrap);
    var labelEl = qs("[data-urbixx-country-label]", wrap);
    var hidden = qs("[data-urbixx-country-hidden]", wrap);
    var items = qsa(".urbixx-country-item", wrap);

    function open() {
      if (!menu || !btn) return;
      menu.hidden = false;
      btn.setAttribute("aria-expanded", "true");
      try { menu.focus(); } catch (e) {}
    }

    function close() {
      if (!menu || !btn) return;
      menu.hidden = true;
      btn.setAttribute("aria-expanded", "false");
    }

    if (btn && menu) {
      btn.addEventListener("click", function() {
        if (menu.hidden) open();
        else close();
      });
    }

    items.forEach(function(it) {
      it.addEventListener("click", function() {
        try {
          var code = it.getAttribute("data-code") || "+31";
          var label = it.getAttribute("data-label") || "NL";
          if (codeEl) codeEl.textContent = code;
          if (labelEl) labelEl.textContent = label;
          if (hidden) hidden.value = code;
        } catch (e) {}
        close();
      });
    });

    document.addEventListener("click", function(e) {
      try {
        if (!menu || menu.hidden) return;
        if (wrap.contains(e.target)) return;
        close();
      } catch (err) {}
    });

    document.addEventListener("keydown", function(e) {
      try {
        if (!menu || menu.hidden) return;
        if (e.key === "Escape" || e.key === "Esc") close();
      } catch (err) {}
    });
  }

  function initEditor() {
    var editor = qs("[data-urbixx-editor]");
    if (!editor) return;

    var area = qs(".urbixx-editor__area", editor);
    var htmlOut = qs("#urbixx-message-html", editor);
    var attachBtn = qs("[data-attach]", editor);
    var fileInput = qs("#urbixx-contact-attachment", editor);

    function syncHtml() {
      try {
        if (!htmlOut) return;
        htmlOut.value = area ? (area.innerHTML || "") : "";
      } catch (e) {}
    }

    if (area) {
      area.addEventListener("input", syncHtml);
      area.addEventListener("blur", syncHtml);
      syncHtml();
    }

    qsa("[data-cmd]", editor).forEach(function(b) {
      b.addEventListener("click", function() {
        try {
          if (!area) return;
          area.focus();
          var cmd = b.getAttribute("data-cmd");
          document.execCommand(cmd, false, null);
          syncHtml();
        } catch (e) {}
      });
    });

    var linkBtn = qs("[data-link]", editor);
    if (linkBtn) {
      linkBtn.addEventListener("click", function() {
        try {
          if (!area) return;
          area.focus();
          var url = window.prompt("Enter a link URL");
          if (!url) return;
          document.execCommand("createLink", false, url);
          syncHtml();
        } catch (e) {}
      });
    }

    if (attachBtn && fileInput) {
      attachBtn.addEventListener("click", function() {
        try { fileInput.click(); } catch (e) {}
      });
    }
  }

  function initFormSubmit() {
    var form = qs("#urbixx-contact-form");
    if (!form) return;

    var cfg = readConfig() || {};
    var apiBaseUrl = cfg.apiBaseUrl || "https://urbixx-booking-backend.onrender.com";
    var maxBytes = typeof cfg.maxUploadBytes === "number" ? cfg.maxUploadBytes : 5242880;

    var successEl = qs("#urbixx-contact-success");
    var errorEl = qs("#urbixx-contact-error");
    var submitBtn = qs(".urbixx-contact-submit__btn", form);
    var fileInput = qs("#urbixx-contact-attachment");

    function show(el) {
      if (!el) return;
      el.hidden = false;
      try { el.focus(); } catch (e) {}
    }
    function hide(el) { if (el) el.hidden = true; }

    function buildPhone() {
      var cc = (qs("[data-urbixx-country-hidden]") || {}).value || "+31";
      var local = (qs("#urbixx-contact-phone-local") || {}).value || "";
      local = String(local).trim();
      if (!local) return "";
      return (String(cc).trim() + " " + local).trim();
    }

    function fileTooLarge(file) {
      try { return file && typeof file.size === "number" && file.size > maxBytes; } catch (e) { return false; }
    }

    if (fileInput) {
      fileInput.addEventListener("change", function() {
        try {
          if (!fileInput.files || !fileInput.files[0]) return;
          if (fileTooLarge(fileInput.files[0])) {
            alert("Attachment is too large. Max 5MB.");
            fileInput.value = "";
          }
        } catch (e) {}
      });
    }

    form.addEventListener("submit", async function(e) {
      e.preventDefault();
      hide(successEl);
      hide(errorEl);

      // Basic validation
      var firstName = (qs("#urbixx-contact-firstname") || {}).value || "";
      var email = (qs("#urbixx-contact-email") || {}).value || "";
      var consent = (qs("#urbixx-contact-consent") || {}).checked;
      firstName = String(firstName).trim();
      email = String(email).trim();

      if (!firstName || !email || !consent) {
        show(errorEl);
        if (errorEl) errorEl.textContent = "Please fill in the required fields.";
        return;
      }

      var fd = new FormData();
      fd.append("firstName", firstName);
      fd.append("email", email);
      fd.append("phone", buildPhone());
      fd.append("messageHtml", (qs("#urbixx-message-html") || {}).value || "");

      if (fileInput && fileInput.files && fileInput.files[0]) {
        var f = fileInput.files[0];
        if (fileTooLarge(f)) {
          show(errorEl);
          if (errorEl) errorEl.textContent = "Attachment is too large. Max 5MB.";
          return;
        }
        fd.append("attachment", f, f.name);
      }

      try {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = "Sending…";
        }

        var res = await fetch(apiBaseUrl.replace(/\/$/, "") + "/api/contact-message", {
          method: "POST",
          body: fd
        });

        if (!res.ok) {
          var txt = "";
          try { txt = await res.text(); } catch (e0) {}
          throw new Error(txt || ("HTTP " + res.status));
        }

        // Success
        show(successEl);
        form.reset();
        // Clear editor
        var area = qs("#urbixx-message-editor");
        if (area) area.innerHTML = "";
        var htmlOut = qs("#urbixx-message-html");
        if (htmlOut) htmlOut.value = "";
      } catch (err) {
        show(errorEl);
        if (errorEl) errorEl.textContent = "Something went wrong. Please try again.";
      } finally {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = "Send message";
        }
      }
    });
  }

  document.addEventListener("DOMContentLoaded", function() {
    if (!document.body || !document.body.classList.contains("template-page-contact")) return;
    initCountrySelect();
    initEditor();
    initFormSubmit();
  });
})();

/* Urbixx — Contact page premium interactions */
(() => {
  const prefersReduced = () =>
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const onReady = (fn) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  };

  const initReveals = () => {
    if (prefersReduced()) return;
    // New premium contact section uses explicit data attribute for reveals
    const els = Array.from(
      document.querySelectorAll('.template-page-contact [data-urbixx-reveal]')
    );
    if (!els.length) return;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -10% 0px' }
    );

    els.forEach((el) => io.observe(el));
  };

  const initWhatsAppFab = () => {
    const fab = document.querySelector('[data-urbixx-wa-fab]');
    if (!fab) return;

    const button = fab.querySelector('.urbixx-wa-fab__button');
    const panel = fab.querySelector('.urbixx-wa-fab__panel');
    if (!button || !panel) return;

    const open = () => {
      fab.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      panel.hidden = false;
      // tick feel
      fab.classList.add('is-tap');
      window.setTimeout(() => fab.classList.remove('is-tap'), 120);
    };

    const close = () => {
      fab.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
    };

    const toggle = () => {
      if (fab.classList.contains('is-open')) close();
      else open();
    };

    button.addEventListener('click', toggle);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });

    document.addEventListener('click', (e) => {
      if (!fab.classList.contains('is-open')) return;
      if (!fab.contains(e.target)) close();
    });

    // Desktop: open on hover, but don't trap mobile
    const finePointer =
      window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    if (finePointer) {
      fab.addEventListener('mouseenter', open);
      fab.addEventListener('mouseleave', close);
    }
  };

  onReady(() => {
    if (!document.body.classList.contains('template-page-contact')) return;
    initReveals();
    initWhatsAppFab();
  });
})();


